
import { Component, Vue, Prop, Inject } from "vue-property-decorator";
import Loader from "../components/Loader.vue";
import { QuiltyInsightsListItem } from "@gsx/common/src/types/http/dashboard/quiltyInsights";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { Container } from "inversify";
import { Api } from "../../../../common/src/api/Api";
import { QuiltyInsightsListStore } from "../../stores/quiltyInsights/QuiltyInsightsListStore";
import { escapeRegExp } from "../../../../../server/src/utils";
import Swal from "sweetalert2";

@Component({
    components: { Loader },
})
export default class SocialFeed extends Vue {
    @Prop() quiltyInsightsListItem!: QuiltyInsightsListItem;

    @Inject("container") readonly container!: Container;
    readonly listStore: QuiltyInsightsListStore = this.container.get(QuiltyInsightsListStore);
    readonly authStore: AuthStore = this.container.get(AuthStore);
    readonly api: Api = this.container.get(Api);
    showMore = false;

    data() {
        return {
            showMore: false,
        };
    }

    get isNewsLiked() {
        if (
            this.quiltyInsightsListItem?.likes !== undefined &&
            this.authStore.user?.userid !== undefined
        ) {
            return this.quiltyInsightsListItem?.likes?.includes(this.authStore.user?.userid);
        }
        return false;
    }

    get newsLikesCount() {
        if (this.quiltyInsightsListItem?.likes !== undefined)
            return this.quiltyInsightsListItem.likes.length;
        else return 0;
    }

    organizationUrl(organizationId: string) {
        return `/dashboard/organizations/${organizationId}`;
    }

    async toggleLike() {
        if (this.authStore.user) {
            if (this.isNewsLiked) {
                const index = this.quiltyInsightsListItem?.likes?.findIndex(
                    (likedUserId) => likedUserId === this.authStore.user?.userid,
                );
                if (index >= 0) {
                    this.quiltyInsightsListItem.likes.splice(index, 1);
                }
            } else {
                this.quiltyInsightsListItem.likes.push(this.authStore.user?.userid);
            }
        }

        await this.api.dashboard.quiltyInsights.toggle(
            this.quiltyInsightsListItem.quiltyInsightsId,
        );
    }

    copyUrl() {
        const shareLink = String(
            window.location.href + "/" + this.quiltyInsightsListItem.title,
        ).replace(/ /g, "%20");
        navigator.clipboard
            .writeText(shareLink.valueOf())
            .then(() => {
                Swal.fire({
                    title: "URL has been copied to clipboard",
                    text: shareLink,
                });
            })
            .catch(() => {
                alert("Something went wrong");
            });
    }

    toggleShowMore() {
        this.showMore = !this.showMore;
    }

    searchingTag(tag: string) {
        if (this.listStore.query) {
            const regexp = new RegExp(escapeRegExp(this.listStore.query.trim()), "i");
            if (regexp.test(tag)) {
                return "primary";
            }
        }

        return "secondary";
    }

    get isOverflowTextLength() {
        const overflow = 1080;
        return this.quiltyInsightsListItem.narrative.length > overflow;
    }

    get getClass() {
        return {
            "mdi mdi-thumb-up text-success": this.isNewsLiked,
            "mdi mdi-thumb-up-outline": !this.isNewsLiked,
        };
    }
}
